import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  key: 0,
  class: "TUIKit-navbar"
};
var _hoisted_2 = ["onClick"];
var _hoisted_3 = ["src"];
var _hoisted_4 = {
  class: "TUIKit-main-container"
};
var _hoisted_5 = {
  key: 0,
  class: "TUIKit-main"
};
var _hoisted_6 = {
  key: 0,
  class: "TUIKit-main-aside"
};
var _hoisted_7 = {
  class: "Iris-search"
};
var _hoisted_8 = {
  key: 1,
  class: "TUIKit-main-main"
};
var _hoisted_9 = {
  key: 1,
  class: "TUIKit-main"
};
var _hoisted_10 = {
  key: 2,
  class: "TUIKit-main"
};
var _hoisted_11 = {
  key: 3,
  class: "TUIKit-main"
};
import blknews from '@/views/instant_messages/components/blknews.vue';
import aiquestion from '@/views/instant_messages/components/aiquestion.vue';
import { ref, onMounted, framework, reactive } from './adapter-vue';
import { TUILogin } from '@tencentcloud/tui-core';
import { TUIStore, StoreName, TUIConversationService } from '@tencentcloud/chat-uikit-engine';
import SearchMore from './components/TUISearch/search-more/index.vue';
import { TUISearch, TUIConversation, TUIChat, TUIContact, TUIGroup } from './components';
import { isH5 } from './utils/env';
import { useTimStore } from '../store/tim';
import { usecommonStore } from '../store/common';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    // 部署生产环境时不需要通过 props 传入 SDKAppID、userID、userSig
    // eslint-disable-next-line vue/prop-name-casing
    SDKAppID: {
      type: Number,
      default: 0,
      required: false
    },
    userID: {
      type: String,
      default: '',
      required: false
    },
    userSig: {
      type: String,
      default: '',
      required: false
    },
    conversationID: {
      type: String,
      default: '',
      required: false // 独立集成 Chat 时需要传 conversationID
    }
  },
  setup(__props) {
    var timStore = useTimStore();
    var commonStore = usecommonStore();
    var search = reactive({
      key_word: ''
    });
    var key_word = ref(''); //搜索关键词
    var _currentConversationID = ref('');
    var navbarList = [{
      id: 'blknews',
      label: '消息',
      icon: 'icon-lingdang'
    }, {
      id: 'blkai',
      label: '你问我答',
      icon: 'icon-zhinengwendabeifen'
    }, {
      id: 'conversation',
      label: '会话',
      icon: 'icon-xiaoxi2'
    }, {
      id: 'contact',
      label: '通讯录',
      icon: 'icon-gerenziliao'
    }];
    var props = __props;
    onMounted(() => {
      // 监听当前会话 ID
      TUIStore.watch(StoreName.CONV, {
        currentConversationID: id => {
          _currentConversationID.value = id;
        }
      });
      // 默认登录逻辑
      login();
      // H5 环境下修改 CallKit 样式
      modifyCallKitStyle();
    });
    function login() {
      var {
        SDKAppID,
        userID,
        userSig,
        conversationID
      } = props;
      if (SDKAppID && userID && userSig) {
        TUILogin.login({
          SDKAppID,
          userID,
          userSig,
          useUploadPlugin: true,
          framework
        }).then(() => {
          // 独立集成 Chat 时执行以下代码
          if (conversationID.startsWith('C2C') || conversationID.startsWith('GROUP')) {
            TUIConversationService.switchConversation(conversationID);
          }
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
        }).catch(error => {});
      }
    }
    function modifyCallKitStyle() {
      if (isH5) {
        var bodyStyle = document.getElementsByTagName('body')[0].style;
        bodyStyle.setProperty('--callLeft', '0');
        bodyStyle.setProperty('--callTop', '0');
        bodyStyle.setProperty('--callWidth', '100%');
        bodyStyle.setProperty('--callHeight', '100%');
      }
    }
    var handle_keydown = e => {
      // console.log("e-->", e)
      if (e.keyCode == 13) {
        timStore.keyword = search.key_word;
        console.log("timstore.key_word->", timStore.keyword);
      }
    };
    var handle_input = () => {
      console.log("input--->", search.key_word);
      timStore.keyword = search.key_word;
      console.log("timstore.key_word->", timStore.keyword);
    };
    var handle_click_icons = item => {
      commonStore.set_activenews(item.id);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "default", {}, () => [_createElementVNode("div", {
        class: _normalizeClass(['TUIKit', _unref(isH5) && 'TUIKit-h5'])
      }, [!(_unref(isH5) && _unref(_currentConversationID)) ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(navbarList, item => {
        return _createElementVNode("div", {
          key: item.id,
          class: _normalizeClass(['TUIKit-navbar-item', _unref(commonStore).activenews === item.id && 'TUIKit-navbar-item-active']),
          onClick: $event => handle_click_icons(item)
        }, [item.id == 'blkai' ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          style: {
            "width": "27px",
            "margin-left": "2px"
          },
          src: _unref(commonStore).activenews === item.id ? 'https://www.bio-cloud.com.cn:8022/icon/ai_logo.png' : 'https://www.bio-cloud.com.cn:8022/icon/ai_logo_gray.png',
          alt: ""
        }, null, 8, _hoisted_3)) : (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass({
            'iconfont': true,
            [item.icon]: true,
            'active': _unref(commonStore).activenews === item.id
          })
        }, null, 2))], 10, _hoisted_2);
      }), 64))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_unref(commonStore).activenews === 'conversation' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [!(_unref(isH5) && _unref(_currentConversationID)) ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_withDirectives(_createElementVNode("input", {
        onKeydown: handle_keydown,
        onInput: handle_input,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(search).key_word = $event),
        class: "Iris-search-main",
        type: "text",
        placeholder: "搜索",
        focus: false
      }, null, 544), [[_vModelText, _unref(search).key_word]]), _createVNode(SearchMore, {
        class: "search-more",
        searchType: "global"
      })]), _createVNode(_unref(TUIConversation))])) : _createCommentVNode("", true), !_unref(isH5) || _unref(_currentConversationID) ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(_unref(TUIChat)), _createVNode(_unref(TUIGroup), {
        class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside')
      }, null, 8, ["class"]), _createVNode(_unref(TUISearch), {
        class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside'),
        searchType: "conversation"
      }, null, 8, ["class"])])) : _createCommentVNode("", true), _unref(isH5) && !_unref(_currentConversationID) ? (_openBlock(), _createBlock(_unref(TUIGroup), {
        key: 2,
        class: "chat-popup"
      })) : _createCommentVNode("", true), _createVNode(_unref(TUIContact), {
        displayType: "selectFriend"
      })])) : _unref(commonStore).activenews === 'contact' ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_unref(TUIContact), {
        displayType: "contactList",
        onSwitchConversation: _cache[1] || (_cache[1] = $event => _unref(commonStore).set_activenews('conversation'))
      })])) : _unref(commonStore).activenews === 'blknews' ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(blknews)])) : _unref(commonStore).activenews === 'blkai' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(aiquestion)])) : _createCommentVNode("", true)])], 2)])]);
    };
  }
});